<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>会员管理</el-breadcrumb-item>
            <el-breadcrumb-item>会员列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-input placeholder="请输入会员手机号" clearable v-model="queryInfo.mobile" @clear="handleQuery()" style="width: 200px;margin-right:10px">
                        <el-button slot="append" icon="el-icon-search" @click="handleQuery()"></el-button>
                    </el-input>
                    <el-input placeholder="请输入会员昵称" clearable v-model="queryInfo.nickname" @clear="handleQuery()" style="width: 200px;margin-right:10px">
                        <el-button slot="append" icon="el-icon-search" @click="handleQuery()"></el-button>
                    </el-input>
                    <el-select v-model="queryInfo.query4"  placeholder="请选择门店" @change="handleQuery()"  style="margin-left:10px" clearable  filterable>
                        <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                    </el-select>
                    <el-select  v-model="queryInfo.query1" clearable  placeholder="请选择角色" @change="handleQuery()"  style="margin:0 10px">
                            <el-option label="用户" value="0"></el-option>
                            <el-option label="助教" value="1"></el-option>
                            <el-option label="店主" value="2"></el-option>
                            <el-option label="保洁" value="3"></el-option>
                            <el-option label="客服" value="4"></el-option>
                    </el-select>
                    <el-select  v-model="queryInfo.query2" clearable  placeholder="是否录脸" @change="handleQuery()"  style="margin-right: 10px">
                            <el-option label="已录" value="1"></el-option>
                            <el-option label="未录" value="0"></el-option>
                    </el-select>
                    <el-select  v-model="queryInfo.query3" clearable  placeholder="是否锁定" @change="handleQuery()"  style="margin-right: 60px">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                    </el-select>
                </el-col>
                <!-- <el-col :span="2" style="line-height: 40px;">
                    <el-checkbox v-model="queryInfo.tx_user" @change="getUserList">提现用户</el-checkbox>
                </el-col>
                <el-col :span="2" style="line-height: 40px;">
                    <el-checkbox v-model="queryInfo.lock_user" @change="getUserList">锁定用户</el-checkbox>
                </el-col> -->
                <!-- <el-col :span="2"></el-col> -->
            </el-row>
            <br>
            <!--搜索与添加区域-->
            <!--用户列表区域-->
            <el-table :data="userlist"  :key="userlist.index" v-loading="loading" style="width: 100%" stripe size="middle" height="700">
                <!-- <el-table-column label="ID" type="index"  width="40"></el-table-column> -->
                <el-table-column label="ID" width="50">
                    <template slot-scope="scope">
                        {{ (queryInfo.pagenum - 1) * queryInfo.pagesize + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column label="初始头像" prop="username" width="80">
                  <template slot-scope="scope">
                    <div>
                      <el-popover placement="bottom"  width="310" trigger="click">
                        <div style="text-align: center;">
                          <img :src="ossURL+scope.row.username+'.png'" mode="cover"  style="width:300px;height: 300px;border-radius: 5px;"/>
                        </div>
                        <img  slot="reference" :src="ossURL+scope.row.username+'.png'" style="height: 30px;width: 30px;border-radius: 50%;">
                      </el-popover>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="最新头像" prop="username" width="80">
                  <template slot-scope="scope">
                    <div>
                      <el-popover placement="bottom"  width="310" trigger="click">
                        <div style="text-align: center;">
                          <img :src="ossURL+scope.row.username+'now.png'" mode="cover"  style="width:300px;height: 300px;border-radius: 5px;"/>
                        </div>
                        <img  slot="reference" :src="ossURL+scope.row.username+'now.png'" style="height: 30px;width: 30px;border-radius: 50%;">
                      </el-popover>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="用户名" prop="username" width="120"></el-table-column>
                <el-table-column label="昵称" prop="nickname" width="150" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column label="性别" prop="sex" width="50" :show-overflow-tooltip="true"></el-table-column>
<!--                <el-table-column label="OpenId" prop="openid" width="300" :show-overflow-tooltip="true"></el-table-column>-->
                <!-- <el-table-column label="性别" prop="sex" width="80"></el-table-column>
                <el-table-column label="年龄" prop="age" width="80"></el-table-column> -->

                <!-- <el-table-column label="禁止购卡" prop="iscard" width="100">
                    <template  slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.iscard == '0'">否</el-tag>
                        <el-tag type="danger" v-else>是</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="禁止门禁" prop="isdoor" width="100">
                    <template  slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.isdoor == '0'">否</el-tag>
                        <el-tag type="danger" v-else>是</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="禁止录脸" prop="isface" width="100">
                    <template  slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.isface == '0'">否</el-tag>
                        <el-tag type="danger" v-else>是</el-tag>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column label="是否店主" prop="ismanager" width="100">
                    <template  slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.ismanager == '0'">否</el-tag>
                        <el-tag type="danger" v-else>是</el-tag>
                    </template>
                </el-table-column> -->

                <el-table-column label="注册门店" prop="storename" width="300" :show-overflow-tooltip="true"></el-table-column>

                <el-table-column label="注册时间" prop="adddate" width="180"></el-table-column>
                <el-table-column label="角色" prop="role" width="80">
                    <template  slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.role == '0'">用户</el-tag>
                        <el-tag type="danger" v-if="scope.row.role == '1'">助教</el-tag>
                        <el-tag type="warning" v-if="scope.row.role == '2'">店主</el-tag>
                        <el-tag  v-if="scope.row.role == '3'">保洁</el-tag>
                        <el-tag type="info" v-if="scope.row.role == '4'">客服</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="是否录脸" prop="isface" width="80">
                    <template slot-scope="scope">
                        <el-tag type="info" v-if="scope.row.isface == '0'">否</el-tag>
                        <el-tag type="success" v-else>是</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="是否锁定" prop="islock" width="80">
                    <template  slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.islock == '0'">否</el-tag>
                        <el-tag type="danger" v-else>是</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <!--作用域插槽-->
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="EditUser(scope.row.username)" v-permission="'btn:user:edit'"></el-button>
                        <el-button type="danger" icon="el-icon-video-pause" size="mini" @click="StopCard(scope.row)" v-permission="'btn:user:stop'">停卡</el-button>
                        <el-button type="warning" size="mini" @click="BuyList(scope.row.username)" v-permission="'btn:user:buylist'">购卡记录</el-button>
                        <el-button type="danger" size="mini" @click="ClearWxInfo(scope.row.username)" v-if="scope.row.openid" v-permission="'btn:user:clearWxInfo'">清除微信信息</el-button>
                        <el-button type="info" size="mini" @click="ClearNsCer(scope.row.username)" v-if="scope.row.idcard" v-permission="'btn:user:clearNsCer'">清除女神认证</el-button>
                        <el-button type="danger" size="mini" @click="RecordList(scope.row.username)" v-permission="'btn:user:recordlist'">到店记录</el-button>
                        <el-button type="success" size="mini" @click="DelFace(scope.row.username, scope.row.storeid)" v-permission="'btn:user:delface'" v-if="scope.row.isface == '1'">删除人脸</el-button>
                        <el-button type="success" size="mini" @click="AddFace(scope.row)" v-permission="'btn:user:addface'" v-if="scope.row.isface == '0'">人脸录入</el-button>
                        <!-- <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelUser(scope.row.username)"></el-button> -->
                        <!-- <el-tooltip class="item" effect="dark" content="提现记录" placement="top">
                            <el-button type="warning" icon="el-icon-sort" size="mini" @click="TiXian(scope.row.username)"></el-button>
                        </el-tooltip> -->
                </template>
                </el-table-column>
            </el-table>
            <!--用户列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[20,50,500,1000]"  :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
            <!--添加用户对话框-->
            <el-dialog title="添加会员" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
                <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="100px">
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="addForm.username"></el-input>
                    </el-form-item>
                    <el-form-item label="是否是店主" prop="ismanager">
                        <el-switch active-value="1" inactive-value="0" v-model="addForm.ismanager"></el-switch>
                    </el-form-item>
                    <el-form-item label="是否是保洁" prop="isbaojie">
                        <el-switch active-value="1" inactive-value="0" v-model="addForm.isbaojie"></el-switch>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addUser" v-permission="'btn:user:add'">确 定</el-button>
                </span>
            </el-dialog>
            <!--添加用户对话框-->
            <!--编辑用户对话框-->
            <el-dialog title="编辑会员" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
                <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="editForm.username" readonly></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="是否是店主" prop="role">
                        <el-switch active-value="2" inactive-value="0" v-model="editForm.role"></el-switch>
                    </el-form-item> -->
                    <el-form-item label="选择角色" prop="role">
                        <el-select  v-model="editForm.role"  placeholder="选择角色"   style="margin-right: 10px">
                            <el-option label="用户" value="0"></el-option>
                            <el-option label="店主" value="2"></el-option>
                            <el-option label="保洁" value="3"></el-option>
                            <el-option label="客服" value="4"></el-option>
                        </el-select>
                    </el-form-item>

                  <el-table :data="storeUserList" style="width: 100%" stripe size="middle" height="700">
                    <el-table-column label="门店" prop="storename" width="120"></el-table-column>
                    <el-table-column label="是否锁定">
                      <template slot-scope="scope">
                        <el-switch active-value="1" inactive-value="0" v-model="scope.row.islock" @change="scope.row.lockRemark = null"></el-switch>
                      </template>
                    </el-table-column>
                    <el-table-column label="锁定原因" width="300">
                      <template slot-scope="scope">
                        <el-input
                            type="textarea"
                            :rows="2"
                            placeholder="请输入锁定原因"
                            v-if="scope.row.islock == '1'"
                            v-model="scope.row.lockRemark">
                        </el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                    <!-- <el-form-item label="禁止在线购卡" prop="iscard">
                        <el-switch active-value="1" inactive-value="0" v-model="editForm.iscard"></el-switch>
                    </el-form-item>
                    <el-form-item label="禁止开启门禁" prop="isdoor">
                        <el-switch active-value="1" inactive-value="0" v-model="editForm.isdoor"></el-switch>
                    </el-form-item>
                    <el-form-item label="是否录入人脸" prop="isface">
                        <el-switch active-value="1" inactive-value="0" v-model="editForm.isface"></el-switch>
                    </el-form-item> -->

                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="editDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="EditUserSave(editForm.username)">确 定</el-button>
                </span>
            </el-dialog>
            <!--编辑用户对话框-->
            <!--提现记录对话框-->
            <!-- <el-dialog title="提现记录" :visible.sync="txDialogVisible" width="60%" >
                <el-card>
                    <el-table :data="txlist0"  :key="txlist0.id" style="width: 100%"  size="small" height="50" :show-header="false" >
                        <el-table-column label="用户" prop="username"></el-table-column>
                        <el-table-column label="提现金额" prop="amount">
                            <template slot-scope="scope">
                            ￥{{scope.row.amount}}
                        </template>
                        </el-table-column>
                        <el-table-column label="提现时间" prop="reg_time"></el-table-column>
                        <el-table-column label="审核状态">
                             <template>
                                 <el-tag type="warning">待审</el-tag>
                             </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-switch :active-value="1" :inactive-value="0" v-model="scope.row.sign" @change="Checked(scope.row.id)"></el-switch>  <span style="color:#ff0000">审核</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
                <br>
                <el-card>
                    <el-table :data="txlist1"  :key="txlist1.id" style="width: 100%" stripe size="small" height="300">
                        <el-table-column label="ID" type="index"></el-table-column>
                        <el-table-column label="提现单号" prop="orderno"></el-table-column>
                        <el-table-column label="用户" prop="username"></el-table-column>
                        <el-table-column label="提现金额" prop="amount">
                            <template slot-scope="scope">
                            ￥{{scope.row.amount}}
                        </template>
                        </el-table-column>
                        <el-table-column label="提现时间" prop="adddate"></el-table-column>
                        <el-table-column label="审核时间" prop="checktime"></el-table-column>
                        <el-table-column label="审核状态">
                             <template>
                                 <el-tag type="success">已审</el-tag>
                             </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-dialog> -->
            <!--提现记录对话框-->
            <!--购卡记录对话框-->
            <el-dialog title="购卡记录" :visible.sync="buyDialogVisible" width="85%" >
                <el-card>
                    <el-table :data="buylist"  :key="buylist.id" style="width: 100%" stripe size="small" height="500">
                        <el-table-column label="ID" type="index" width="50"></el-table-column>
                        <el-table-column label="单号" prop="orderno" width="150"></el-table-column>
                        <el-table-column label="用户" prop="username" width="120"></el-table-column>
                        <el-table-column label="卡名" prop="cardname" width="150" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="display: flex;">
                                    <div style="padding-right: 5px;line-height: 30px;">
                                        {{ scope.row.cardname }}
                                    </div>
                                    <div v-if="scope.row.cardclass == '体验卡'">
                                        <el-tag type="danger" v-if="scope.row.istuikuan == '1'">退款</el-tag>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="购卡门店" prop="storename" width="120" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column label="价格" prop="amount" width="80"></el-table-column>
                        <el-table-column label="来源" prop="cardfrom" width="220">
                            <template slot-scope="scope">
                                <el-tag type="success" v-if="scope.row.cardfrom == '0'">平台</el-tag>
                                <el-tag type="danger" v-if="scope.row.cardfrom == '1'">抖音</el-tag>
                                <el-tag type="warning" v-if="scope.row.cardfrom == '2'">美团</el-tag>
                                <el-tag v-if="scope.row.cardfrom == '7'">高德</el-tag>
                                <el-tag type="primary" v-if="scope.row.cardfrom == '3'">赠送</el-tag>
                                <el-tag type="info" v-if="scope.row.cardfrom == '4'">分享</el-tag>
                                <el-tag type="info" v-if="scope.row.cardfrom == '5'" effect="dark">异业</el-tag>
                                <span v-if="scope.row.cardfrom == '1' || scope.row.cardfrom == '7'" style="padding-left: 10px;">劵码：{{ scope.row.extra }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="到期时间" prop="endtime" width="150"></el-table-column>

                        <el-table-column label="收款商户" prop="mchid" width="100"></el-table-column>
                        <el-table-column label="状态" prop="status"  width="100">
                            <template slot-scope="scope">
                                <el-tag type="success" v-if="scope.row.status == '0'">有效</el-tag>
                                <el-tag type="info" v-if="scope.row.status == '1'">失效</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="购买日期" prop="adddate" ></el-table-column>
                    </el-table>
                </el-card>
            </el-dialog>
            <!--购卡记录对话框-->
            <!--到店记录对话框-->
            <el-dialog title="到店记录" :visible.sync="recordDialogVisible" width="70%" @open="initRecordDate">
                <el-card>
                   <el-form :inline="true" style="margin-bottom: 10px;">
                     <el-form-item label="日期" required>
                       <el-date-picker
                         v-model="recordDateRange"
                         type="daterange"
                         align="right"
                         unlink-panels
                         range-separator="至"
                         start-placeholder="开始日期"
                         end-placeholder="结束日期"
                         value-format="yyyy-MM-dd"
                         :picker-options="recordPickerOptions"
                         @change="onRecordDateChange">
                       </el-date-picker>
                     </el-form-item>
                     <el-form-item>
                       <el-button type="primary" icon="el-icon-search" @click="searchRecords">查询</el-button>
                     </el-form-item>
                   </el-form>
                   <el-table :data="recordlist"  :key="recordlist.id" style="width: 100%" stripe size="small" height="500">
                        <el-table-column label="ID" type="index" width="50"></el-table-column>
                        <el-table-column label="用户" prop="username" width="150"></el-table-column>
                        <el-table-column label="卡名" prop="cardname" width="280" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="display: flex;">
                                    <div style="padding-right: 5px;line-height: 30px;">
                                        {{ scope.row.cardname }}
                                    </div>
                                    <div v-if="scope.row.cardclass == '体验卡'">
                                        <el-tag type="danger" v-if="scope.row.istuikuan == '1'">退款</el-tag>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="购卡门店" prop="storename" width="300" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column label="状态" prop="type"  width="100">
                            <template slot-scope="scope">
                                <el-tag type="success" v-if="scope.row.type == 'in'">进门</el-tag>
                                <el-tag type="danger" v-if="scope.row.type == 'out'">出门</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="时间" prop="recordtime" ></el-table-column>
                    </el-table>
                </el-card>
            </el-dialog>
            <!--购卡记录对话框-->
          <!--停卡对话框-->
          <el-dialog title="停卡" :visible.sync="stopDialogVisible" width="60%">
            <div style="padding-bottom: 20px;font-size: 20px;">会员账号：{{ stopcardusername }}</div>
            <el-card>
              <div>
                <span>停卡天数：</span>
                <el-input-number v-model="stopParam.stopdays" :min="1" :max="365" label="天"></el-input-number> <span style="padding-left: 10px;padding-right: 30px;">天</span>
                <span>停卡门店：</span>
                <el-select filterable v-model="stopParam.storeid" clearable placeholder="请选择门店">
                  <el-option
                      v-for="item in stores"
                      :key="item.id"
                      :label="item.storename"
                      :value="item.id">
                  </el-option>
                </el-select>
                <el-button type="primary" @click="StopCardSave()" v-permission="'btn:user:stop:save'" style="margin-left: 10px">确 定</el-button>
              </div>
            </el-card>
            <br>
            <el-card>
              <div slot="header" class="clearfix">
                停卡记录
              </div>
              <el-table :data="stoplist" style="width: 100%"  stripe size="small" height="400">
                <el-table-column label="序号" type="index" width="50"></el-table-column>
                <el-table-column label="门店" prop="storename" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="停卡天数" prop="days" width="100"></el-table-column>
                <el-table-column label="停卡开始时间" prop="starttime" width="150"></el-table-column>
                <el-table-column label="停卡结束时间" prop="endtime" width="150"></el-table-column>
                <el-table-column label="标识" prop="sign" width="100">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.sign === '0'">停卡中</el-tag>
                    <el-tag v-if="scope.row.sign === '1'" type="danger">停卡结束</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作日期" prop="adddate"></el-table-column>
                <el-table-column label="操作" width="200" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" @click="restoreCard(scope.row)" v-permission="'btn:user:restore'" v-if="scope.row.sign === '0'">恢复正常</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-dialog>
          <!--停卡对话框-->
        </el-card>

      <el-dialog title="添加人脸" :visible.sync="faceAddDisable" width="30%">
        <el-form label-width="120px">
          <el-form-item label="人脸照片" prop="goods_pic">
            <el-upload
                ref="imgBroadcastUpload"
                :limit="1"
                :auto-upload="true"
                :file-list="fileList"
                :on-success="addPic"
                :data="faceForm"
                list-type="picture-card"
                accept="image/*"
                :action="uploadurl">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
       //验证手机的规则
      var checkMobile = (rule,value,cb) => {
        const regMobile = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/
        if(regMobile.test(value)){
          return cb()
        }
        cb(new Error('请输入合法的手机号！'))
      }
      return{
        loading: false,
        ossURL: this.ossURL,
        stores: [],
        stopcardusername: null,
        stopParam:{
          stopdays:1,
          storeid: null
        },
        stoplist:[],
        stopDialogVisible: false,
        queryInfo: {
            mobile: '',
            nickname: '',
            query1:'',
            query2:'',
            query3:'',
            query4:'',
            pagenum: 1,
            pagesize: 20
        },
        total:0,
        userlist: [],
        storelist:[],
        txlist0:[],
        txlist1:[],
        buylist:[],
        recordlist:[],
        currentRecordUsername: '',
        addDialogVisible:false,
        editDialogVisible:false,
        txDialogVisible:false,
        buyDialogVisible:false,
        recordDialogVisible:false,
        recordDateRange: [],
        recordSearchStartdate: '',
        recordSearchEnddate: '',
        recordPickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
        },
        addForm:{
             username:'',
             ismanager:0,
             isbaojie:0
        },
         //编辑表单数据
         editForm:{
            username:'',
            iscard:0,
            isdoor:0,
            isface:0,
            ismanager:0,
            isbaojie:0,
            islock:0,
            admin_token:'',
           lockRemark: '',
           storeid:null,
        },

        //添加表单验证规则
        addFormRules:{
            username:[
                { required: true, message: '请输入用户名', trigger: 'blur' },
                { validator: checkMobile, trigger: 'blur'}
            ]
        },
        editFormRules:{
            // username:[
            //     { required: true, message: '请输入用户名', trigger: 'blur' },
            //     { validator: checkMobile, trigger: 'blur'}
            // ]
        },
        faceAddDisable:false,
        faceForm:{
          nickname: null,
          storeid: null,
          username: null
        },
        uploadurl: this.GLOBAL.imgURL+'uploadUserFace/',
        fileList: [],
        storeUserList: []
      }
    },
    created() {
         this.GetStore()
         this.handleQuery()
    },
    mounted(){
        this.admin_token = window.sessionStorage.getItem('admin_token')
    },
    methods:{
      handleQuery(){
        this.queryInfo.pagenum = 1
        this.getUserList()
      },
        async getUserList() {
          this.loading = true
           const { data: res} = await this.$http.get('userlist/',{ params: this.queryInfo })
          this.loading = false
           if(res.status == 1){
                this.total = res.data.totalCount;
                this.userlist = res.data.list.map(v => {
                //在返回的数据里增加一条数据
                // console.log(v.fields)
                return v.fields
                })
            }
            for (let index = 0; index < res.data.list.length; index++) {
                this.userlist[index].id= res.data.list[index].pk;
            }
            // console.log(this.userlist)
        },
        handleSizeChange(newSize){
          // console.log(newSize)
           this.queryInfo.pagesize = newSize
           this.getUserList()
       },
       handleCurrentChange(newPage){
          // console.log(newPage)
           this.queryInfo.pagenum = newPage
           this.getUserList()
       },
       addDialogClosed(){
            this.$refs.addFormRef.resetFields()
       },

       async addUser(){
              this.$refs.addFormRef.validate( async valid=>{
                if (!valid) return
                const { data:res } = await this.$http.post('useradd/',this.addForm)
                if(res.status===0)
                {
                    this.$message.success('添加用户成功！')
                    this.addDialogVisible = false
                    this.getUserList()
                }
                if(res.status == 1){
                    this.$message.error('此用户已存在！')
                }
              })
       },
       async EditUser(username){
            const { data: res } = await this.$http.get('userinfo/'+username)
            this.editForm = res
            if ( res.role == 1 ){
                this.editForm.role = null
            }
         this.storeUserList = []
            if (res.storeUsers) {
              this.storeUserList = res.storeUsers
            }

            this.editDialogVisible = true
            this.GetStore()
       },
       async GetStore(){
            const { data: res } = await this.$http.get('stores/')
            if(res.code == 0){
                this.storelist = res.data
            }
       },
       EditUserSave(username){
           this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
             let param = {...this.editForm}
                if (this.storeUserList && this.storeUserList.length > 0){
                  param.storeUsers = this.storeUserList
                }
                const { data: res } = await this.$http.post('useredit/' + username,param)
                if (res.status === 0) {
                    this.$message.success('用户修改成功')
                    this.editDialogVisible = false
                    this.getUserList()
                    console.log(this.editForm.islock);
                    var usertype = 0
                    if(this.editForm.islock == 1){
                        usertype = 10
                    }
                }
            })
       },
       editDialogClosed(){
            this.$refs.editFormRef.resetFields()
       },
    //    async DelUser(username){
    //             const confirmResult = await this.$confirm('是否要删除此用户吗?', '提示', {
    //                 confirmButtonText: '确定',
    //                 cancelButtonText: '取消',
    //                 type: 'warning'
    //                 }).catch(err => err)

    //                 if (confirmResult !== 'confirm'){
    //                     return this.$message.info('已取消删除！')
    //                 }
    //                 const { data: res } = await this.$http.get('userdel/'+ username)

    //                 if (res.status === 0) {
    //                     this.$message({message: '删除成功！',type: 'success'})
    //                 }
    //                 this.getUserList()
    //    },
    //    async TiXian(username){
    //       this.txDialogVisible = true
    //       const { data: res} = await this.$http.post('tixianlist/',{ username:username })
    //       this.txlist0 = res.arr0
    //       this.txlist1 = res.arr1
    //    },
    //    async Checked(id){
    //         const confirmResult = await this.$confirm('确定要申请此提现吗?', '提示', {
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //         }).catch(err => err)

    //         if (confirmResult !== 'confirm'){
    //             return this.$message.info('已取消删除！')
    //         }
    //         try {
    //             const { data: res} = await axios.post('https://jianshenapi.tieshouyundong.com/tixian',{ id:id});
    //             console.log("响应数据：", res);
    //             if(res.status === 0){
    //             this.$message({message: '提现审核成功！',type: 'success'})
    //             this.TiXian(res.username)
    //             this.getUserList()
    //         }
    //         } catch (error) {
    //             console.error("请求出错：", error);
    //         }

    //   },
      async BuyList(username){
          this.buyDialogVisible = true
          const { data: res} = await this.$http.post('buylist/',{ username:username })
          if(res.status == 0){
            this.buylist = res.data
          }
      },
      async RecordList(username){
        this.currentRecordUsername = username
        this.recordDialogVisible = true
        this.initRecordDate()
        this.searchRecords()
      },
      initRecordDate() {
        if (this.recordDateRange && this.recordDateRange.length === 2) return
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.recordDateRange = [
          this.formatDate(start),
          this.formatDate(end)
        ]
        this.recordSearchStartdate = this.recordDateRange[0]
        this.recordSearchEnddate = this.recordDateRange[1]
      },
      formatDate(date) {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        return y + '-' + m + '-' + d
      },
      onRecordDateChange(val) {
        if (val && val.length === 2) {
          this.recordSearchStartdate = val[0]
          this.recordSearchEnddate = val[1]
        } else {
          this.recordSearchStartdate = ''
          this.recordSearchEnddate = ''
        }
      },
      async searchRecords() {
        if (!this.recordSearchStartdate || !this.recordSearchEnddate) {
          this.$message.warning('请选择日期范围')
          return
        }
        const { data: res} = await this.$http.post('records/',{
          username: this.currentRecordUsername,
          startdate: this.recordSearchStartdate,
          enddate: this.recordSearchEnddate
        })
        if(res.status == 0){
          this.recordlist = res.data
        }
      },
      async ClearWxInfo(username){
        const confirmResult = await this.$confirm('确定要清除此人微信信息吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(err => err)

        if (confirmResult !== 'confirm'){
          return this.$message.info('已取消清除！')
        }
        const { data: res} = await this.$http.get('clearWxInfo/',{ params: {username:username} })
        if(res.status == 0){
          this.getUserList()
          this.$message({message: '清除成功',type: 'success'})
        }else{
          this.$message.error(res.message)
        }
      },
      async ClearNsCer(username){
        const confirmResult = await this.$confirm('确定要清除此人女神认证信息吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(err => err)

        if (confirmResult !== 'confirm'){
          return this.$message.info('已取消清除！')
        }
        const { data: res} = await this.$http.get('clearNsCer/',{ params: {username:username} })
        if(res.status == 0){
          this.getUserList()
          this.$message({message: '清除成功',type: 'success'})
        }else{
          this.$message.error(res.message)
        }
      },
      async DelFace(username, storeid){
        const confirmResult = await this.$confirm('确定要删除此用户人脸吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
        }).catch(err => err)

        if (confirmResult !== 'confirm'){
            return this.$message.info('已取消删除！')
        }
        const { data: res} = await this.$http.post('delface/',{ admin_token:this.admin_token, username, storeid })
        if(res.status == 0){
            this.getUserList()
            this.$message({message: '删除成功',type: 'success'})
        }else{
            this.$message.error(res.message)
        }
      },
      async AddFace(row){
          this.fileList = []
        this.faceForm.username = row.username
        this.faceForm.nickname = row.nickname
        this.faceForm.storeid = row.storeid
        this.faceAddDisable = true
      },
      async StopCard(info) {
        this.stopcardusername = info.username
        const { data: res } = await this.$http.post('orderstoplist/',{ username:this.stopcardusername})
        if (res.status === 0){
          this.stoplist = res.data
          this.stores = res.stores
        }
        this.stopParam = {
          stopdays:1,
          storeid: null,
          admin_token: null,
          username: info.username
        }
        this.stopDialogVisible = true
      },
      async StopCardSave(){
        if (this.stopParam.storeid) {
          const confirmResult = await this.$confirm('是否要暂停此用户在此门店的会员卡吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).catch(err => err)

          if (confirmResult !== 'confirm'){
            return this.$message.info('已取消删除！')
          }

          this.stopParam.admin_token = window.sessionStorage.getItem('admin_token')
          const { data: res} = await this.$http.post('orderstop/',this.stopParam)
          if (res.status === 0) {
            this.$message({message: '停卡设置成功！',type: 'success'})
          }
          if (res.status === 1) {
            this.$message({message: '设置失败！',type: 'error'})
          }
          this.stopDialogVisible = false
        } else {
          this.$message({message: '停卡必须设置停卡门店',type: 'error'})
        }
      },
      async restoreCard(row){
        const confirmResult = await this.$confirm('是否要恢复此用户会员卡?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(err => err)

        if (confirmResult !== 'confirm'){
          return this.$message.info('已取消删除！')
        }
        const admin_token = window.sessionStorage.getItem('admin_token')
        const { data: res} = await this.$http.post('orderrestore/',{ admin_token:admin_token,id:row.id, storeId: row.storeId,
          username: row.username, starttime: row.starttime})
        if (res.status === 0) {
          this.$message({message: '设置成功！',type: 'success'})
        }
        if (res.status === 1) {
          this.$message({message: '设置失败！',type: 'error'})
        }
        this.stopDialogVisible = false
      },
      addPic(file){
        if (file.status == '0') {
          this.$message({message: '上传成功！',type: 'success'})
          this.getUserList()
          this.faceAddDisable = false
        } else {
          this.fileList = []
          this.$message({message: file.msg,type: 'error'})
        }
      },
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    .el-table::before {
    height: 0px;

    }
</style>
